module.exports = __webpack_public_path__ + "img/user-menu-account.3d9d8973.svg";